import useDataFetcher from '~/components/useDataFetcher';
import type { RecipientOptionItemList } from '~/server_shared/openapi/data-contracts';

interface UseFetchAutoCommRecipientOptionsReturnType {
  recipientOptions: RecipientOptionItemList;
  isLoading: boolean;
  isError: boolean;
}

const useFetchAutoCommRecipientOptions = (
  organizationId: number,
  { shouldFetch = true }: { shouldFetch?: boolean } = {}
): UseFetchAutoCommRecipientOptionsReturnType => {
  const { data, isLoading, isError } = useDataFetcher<RecipientOptionItemList>(
    `/api/v1/organizations/${organizationId}/automatic_communications/recipient_options`,
    null,
    shouldFetch
  );

  return {
    recipientOptions: data || [],
    isLoading,
    isError,
  };
};

export default useFetchAutoCommRecipientOptions;
